import styles from './Projects.module.css';

import posts from '../../json/posts.json';
import PostCard from "../../components/PostCard";
import PostModel from '../../components/PostModel';
import fotoCapa from "../../assets/about_me_head.png";

export default function Projects() {
    return (
        <PostModel
        fotoCapa={fotoCapa}
        title="Projetos"
        >
            <ul className={styles.posts}>
                    {posts.map((post) => (
                        <li key={post.id}>
                            <PostCard post={post} />
                        </li>
                    ))}
                </ul>
        </PostModel>
    )
}